module.exports = __webpack_public_path__ + "static/media/health.4b11c491.svg";